import { render, staticRenderFns } from "./LLTextarea.vue?vue&type=template&id=27537341&scoped=true"
import script from "./LLTextarea.vue?vue&type=script&lang=js"
export * from "./LLTextarea.vue?vue&type=script&lang=js"
import style0 from "./LLTextarea.vue?vue&type=style&index=0&id=27537341&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27537341",
  null
  
)

export default component.exports